export default "__VITE_ASSET__BkNt$0gL__"